// extracted by mini-css-extract-plugin
module.exports = {"addonWrapper":"LegacyHeader-module-addon-wrapper","isHidden":"LegacyHeader-module-is-hidden","visibleOnMobile":"LegacyHeader-module-visible-on-mobile"};